import { Chip, Typography } from "@mui/material";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

export function CampaignContactFieldChip({
  fieldName,
}: {
  fieldName: string;
}): ReactElement {
  return (
    <Chip
      sx={{
        background: palette.midBlue,
        color: palette.navy,
        height: "21px",
      }}
      label={<Typography variant="body2">{`{${fieldName}}`}</Typography>}
    />
  );
}
